import { useEffect, useState } from 'preact/hooks';
import { appState, type AppState } from '../app/state';
import { ProfilePicker } from './ProfilePicker';
import { ParentDashboard } from './ParentDashboard';
import { IngestScreen } from './IngestScreen';
import { CombatHud } from './CombatHud';
import { combatBus, type CombatState } from '../app/combatBus';

export function AppShell() {
  const [state, setState] = useState<AppState>(appState.get());
  const [combat, setCombat] = useState<CombatState>(combatBus.get());
  useEffect(() => appState.on(setState), []);
  useEffect(() => combatBus.on(setCombat), []);

  const screen = state.screen;

  // CombatHud is always live when an encounter is in progress, regardless of
  // which Phaser scene "owns" the canvas — combat is a sub-scene of zone, so
  // appState.screen stays 'zone' the whole time. The HUD returns null when
  // phase==='idle', so this is a no-op outside combat.
  // HUD shows only when (a) we're inside a zone and (b) an encounter is active.
  // Outside a zone (academy / parent / ingest) we don't want the HUD bleeding through.
  const showCombatHud = screen.kind === 'zone' && combat.phase !== 'idle';

  return (
    <>
      {screen.kind === 'profile-picker' && <ProfilePicker />}
      {screen.kind === 'parent' && <ParentDashboard onClose={() => appState.goto({ kind: 'academy' })} />}
      {screen.kind === 'ingest' && <IngestScreen onClose={() => appState.goto({ kind: 'academy' })} />}
      {showCombatHud && <CombatHud />}
    </>
  );
}
